import React from "react";
import { Text } from "react-native-paper";
import { View } from "react-native";

const AccordionItemDescriptionOnlyOne = ({styles, j, subSection}) => (
    <View style={{paddingBottom: 10, paddingTop: 10}}>
        <View style={styles.subSection} key={j}>
            <View style={styles.textdescriptionDesignOne}>
                <Text>{subSection[0]}</Text>
            </View>
        </View>
    </View>
);

export default AccordionItemDescriptionOnlyOne;